import _ from 'lodash';

import { Types } from 'app/actions/company-admin/page-vol-events-edit';
import utils from 'app/reducers/utils';

const initialState = {
  volEventId: null,
  loadPending: false,
};

const reducer = utils.createReducer(initialState, {

  [`${Types.LOAD}_PENDING`]: (state, {volEventId}) => {
    return {...state,
      volEventId,
      loadPending: true,
    };
  },
  [`${Types.LOAD}_RESOLVED`]: (state, {volEventId}) => {
    if (volEventId !== state.volEventId) return state;
    return {...state,
      loadPending: false,
    };
  },

});

export default reducer;
